<template>
    <div class="card">
        <div class="card-header bg-transparent fs-5 text-center">{{ title }}</div>
        <ul class="list-group list-group-flush">
            <li
                v-for="item in items"
                :key="item.id"
                class="list-group-item d-flex flex-row justify-content-between"
            >
                <span>{{ item.name }}</span>
                <span>{{ item.quantity }}</span>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import type {SidePanelItemInterface} from "@/components/helpers/Interfaces.ts";

const {title, items} = defineProps<{
    title: string
    items: SidePanelItemInterface[]
}>()
</script>

<style scoped>

</style>
